import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Col, Row, Button,Container} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {IWindow} from "../../index";
import {getEnumOptions} from "../../utils/helper";
import {enums} from "../../Enums";
import _ = require("lodash");
import {LGAPicker} from "../form/fields/LGAPicker";
import {FederalConstituencyPicker} from "../form/fields/FederalConstituencyPicker";
import {StateConstituencyPicker} from "../form/fields/StateConstituencyPicker";
import {WardPicker} from "../form/fields/WardPicker";
import {SenatorialDistrictPicker} from "../form/fields/SenatorialDistrictPicker";
import {HasPermission} from "../HasPermission";
import {snakeCase} from "lodash";
import {PollingUnitPicker} from "../form/fields/PollingUnitPicker";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";

const IWindow: IWindow = (window as IWindow);

export class UserFormData {
    @observable name = '';
    @observable role_id = '';
    @observable email = '';
    @observable phone_number = '';
    @observable password = '';
    @observable confirm_password = '';
    @observable is_active = true;
    @observable level = '';
    @observable local_government_areas = [];
    @observable wards = [];
    @observable states = [];
    @observable senatorial_districts = [];
    @observable federal_constituencies = [];
    @observable state_constituencies = [];
    @observable ward_id = null;
    @observable ward = null;
    @observable local_government_area_id = null;
    @observable polling_unit_id = null;
    @observable polling_unit = null;
    @observable is_collation_user = false;
    @observable resetToken = false;
}

@observer
export class UserForm extends CrudForm {
    modelName = 'User';
    @observable candidates = null;
    @observable party_id =  IWindow.initialState.user.party_id;
    candidateIds :any = null;

  

    loadMoreData(props: any, module: any) {
        IWindow.initialState.user.party_id && api.candidate.getListAction({
            filters : {
                party_id: IWindow.initialState.user.party_id,
                active_subscription: 1,
                is_active: 1,
            }
        }).then((data: any) => {
            this.candidates = data;
            this.candidateIds  = _.map(data, 'id');
        });
    }

    stateDropDown() {
        return this.formStore.getValue('level') === 'state' ? <Field
            key={this.formStore.getValue('level') + 'state' +
            this.candidates
            }
            label="States"
            name="states"
            placeholder="Select States"
            component={Select}
            loadOptions={() => {
                return api.state.getListAction({
                    filters: {
                        party_id: this.party_id,
                        candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                        candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                        election_position_id: 1,
                    }
                });
            }}
            store={this.formStore}
            multi={true}
            valueObject={true}
        /> : ''
    };

    lgaDropDown() {
        return this.formStore.getValue('level') === 'lga' ?
            <Field
                key={
                    'lga-drop' + this.formStore.getValue('level') +
                    this.candidates
                }
                label="Local Government Areas"
                placeholder="Local Government Areas"
                name="local_government_areas"
                store={this.formStore}
                component={LGAPicker}
                filters={{
                    party_id: this.party_id,
                    candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                    candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                    election_position_id: 1,
                    is_active: 1
                }}
            /> : ''
    };

    wardsDropDown() {
        return this.formStore.getValue('level') == 'ward' ?
            <Field
                key={this.formStore.getValue('level') + this.candidates + 'ward' }
                label="Ward"
                name="wards"
                placeholder="Wards"
                store={this.formStore}
                component={WardPicker}
                filters={{
                    party_id: this.party_id,
                    candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                    candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                    election_position_id: 1,
                    is_active:1
                }}
            /> : ''
    }

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?
            <Field
                key={'sd-drop' +
                this.formStore.getValue('level')}
                label="Senatorial Districts"
                name="senatorial_districts"
                placeholder="Select Senatorial Districts"
                store={this.formStore}
                component={SenatorialDistrictPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id: 1,
                    is_active:1
                }}
            /> : ''

    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                key={'fc-drop' +
                this.formStore.getValue('level') }
                label="Federal Constituencies"
                name="federal_constituencies"
                placeholder="Select Federal Constituencies"
                store={this.formStore}
                component={FederalConstituencyPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id:1,
                    is_active:1,
                }}
            /> : ''
    }

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?
            <Field
                key={'sc-drop' +
                this.formStore.getValue('level')
                }
                label="State Constituencies"
                name="state_constituencies"
                placeholder="Select State Constituencies"
                store={this.formStore}
                component={StateConstituencyPicker}
                filters={{
                    party_id: this.party_id,
                    level: this.formStore.getValue('level'),
                    candidateIds: this.candidateIds,
                    election_position_id:1,
                    is_active:1
                }}
            /> : ''
    }

    pollingUnitDropDown(){
        return this.formStore.getValue('level') === 'polling_unit' ?
            <>
                <Field
                    key={this.formStore.getValue('level') + 'ward_picker'}
                    label="Ward"
                    multi={false}
                    name="ward"
                    placeholder="Ward"
                    store={this.formStore}
                    component={WardPicker}
                    filters={{
                        candidate_levels: this.candidates ? _.uniq(_.map(this.candidates, 'level')) : null,
                        candidateIds: this.candidates ? _.map(this.candidates, 'id') : null,
                        is_active: 1,
                    }}
                    onChange={(value: any) => {
                        this.formStore.setValue('ward_id', value.id);
                        this.formStore.setValue('polling_unit_id', null);
                    }}
                />
                { this.formStore.getValue('ward_id')  &&
                <Field
                    key={this.formStore.getValue('ward_id') + this.formStore.getValue('level') + 'polling-unit-drop'}
                    label="Polling Unit"
                    name="polling_unit"
                    placeholder="Search Polling Unit"
                    component={PollingUnitPicker}
                    filters={{
                        ward_id: this.formStore.getValue('ward_id')
                    }}
                    multi={false}
                    store={this.formStore}
                    onChange={(value: any) => {
                        this.formStore.setValue('polling_unit_id', value.id);
                    }}
                /> }
            </> : ''
    }

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await api.user.getDetailAction(this.id, null).then((data: any) => {
                this.formStore.setData(data.data);
                this.entity = data.data;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };

    handleChange = () => {
        this.formStore.setValue('resetToken', false);
        if(this.formStore.getValue('is_active') === false){
           if(confirm('Are you sure you want in active user,which will reset mobile user local data?')){
               this.formStore.setValue('resetToken', true);
           }else{
               this.formStore.setValue('is_active', true);
           }
        }
    }

    renderFieldsData() {
        return (
            <>
                <Field
                    label="Name"
                    name="name"
                    component={Input}
                    required={true}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Role"
                    name="role_id"
                    component={Select}
                    required={true}
                    loadOptions={api.role.getListAction}
                    store={this.formStore}
                />

                <Field
                    label="Email"
                    name="email"
                    type="email"
                    component={Input}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Phone number"
                    name="phone_number"
                    component={Input}
                    required={true}
                    autocomplete="off"
                    store={this.formStore}
                />

                <Field
                    label="Password"
                    name="password"
                    type="password"
                    component={Input}
                    store={this.formStore}
                />

                <Field
                    label="Confirm Password"
                    name="confirm_password"
                    type="password"
                    component={Input}
                    store={this.formStore}
                />

                {
                    IWindow.initialState.user.party_id ?
                        <Field
                            label="Level"
                            name="level"
                            placeholder="Select Level"
                            component={Select}
                            options={_.remove(getEnumOptions(enums.userLevel), (level) => {
                            return level.value !== 'superadmin';
                        })}
                            store={this.formStore}
                            onChange={(value:any) => {
                                this.formStore.setValue('local_government_areas', []);
                                this.formStore.setValue('states', []);
                                this.formStore.setValue('wards', []);
                                this.formStore.setValue('senatorial_districts', []);
                                this.formStore.setValue('federal_constituencies', []);
                                this.formStore.setValue('state_constituencies', []);
                                this.formStore.setValue('polling_unit_id', null);
                                this.formStore.setValue('ward', null);
                                if(value === 'poling_unit'){
                                    this.formStore.setValue('is_collation_user', true);
                                }else{
                                    this.formStore.setValue('is_collation_user', false);
                                }
                            }}
                        /> : ''

                }

                {
                    IWindow.initialState.user.party_id && this.formStore.getValue('level') &&
                    this.formStore.getValue('level') !== 'party'
                        ?
                        <>
                            {
                                this.formStore.getValue('level') !== 'polling_unit' ?
                                <Field
                                    name="is_collation_user"
                                    component={BooleanRadios}
                                    trueLabel="Collation"
                                    falseLabel="Non-collation"
                                    store={this.formStore}
                                    helpText="Note: only collation user can login in mobile, only allowed to select single region"

                                /> : ''
                            }

                            {this.stateDropDown()}

                            {this.lgaDropDown()}

                            {this.wardsDropDown()}

                            {this.senatorialDistrictDropDown()}

                            {this.federalConstituencyDropDown()}

                            {this.stateConstituencyDropDown()}

                            {this.pollingUnitDropDown()}
                        </> : ''
                }

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                    onChange={this.handleChange}
                />
            </>
        );
    }
}

export class UserFilterForm {
    @observable role_id = '';
}

export class UserList extends CrudList {
    modelName = 'User';

    colums() {
        return [
            {
                name: "name",
                label: "Name",
            },
            {
                name: "role.name",
                label: "Role",
            },
            {
                name: "email",
                label: "Email",
            },
            {
                name: "phone_number",
                label: "Phone",
            },
        ];
    }

    idColumn() {
        return '';
    }

    defaultActions() {
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any) => {
                return (
                    <>
                        <HasPermission module={snakeCase(this.modelName)} permission="edit">
                            <Button color="grid" onClick={() => this.props.onEdit(value)} size="sm"
                                    className="btn-edit"><span className="icon-edit"/></Button>
                        </HasPermission>
                    </>
                );
            },
            style: {whiteSpace: 'nowrap', textAlign: 'center'},
        }
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3} lg={5} xl={3}>
                    <Field
                        key={'filter_role_id'}
                        name="role_id"
                        placeholder="Select Role"
                        component={Select}
                        required={true}
                        loadOptions={api.role.getListAction}
                        store={this.filterFormStore}
                    />

                </Col>

                <Col md={3} lg={5} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class UserPageModel extends CrudPage {
    modelName = 'User';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/UserPageModel.tsx